import beforeEnterCheck from "@/router/middlewares/beforeEnterCheck";
import checkAuthenticated from '@/router/middlewares/checkAuthenticated';
import checkLinkedEmployee from "@/router/middlewares/checkLinkedEmployee";
import DECORATION_TYPES from '@/router/enums/DECORATION_TYPES';

export default [
  {
    path: '/projects',
    name: 'ProjectsView',
    component: () =>
      import(
        /* webpackChunkName: "projects-view" */ '../modules/projects/components/ProjectsView'
      ),
    meta: {
      moduleId: 'projectsOverview',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    beforeEnter: checkAuthenticated
  },
  {
    path: '/projects/:id',
    name: 'ProjectForm',
    component: () =>
      import(
        /* webpackChunkName: "projects-form" */ '../modules/projects/components/form/ProjectForm'
      ),
    meta: {
      moduleId: 'projectsOverview',
      registries: ['configurations/projects', 'configurations/deviations'],
      preloads: ['system/countries/default'],
    },
    props: true,
    beforeEnter(to, from, next) {
      beforeEnterCheck(to, from, next);
      to.params['showMessageButton'] = false;
    }
  },
  {
      path: '/planningreview',
      name: 'planningReviewView',
      component: () => 
          import(
              /* webpackChunkName: 'planning-review-view' */ '../modules/projects/planning_review/PlanningReviewView'
          ),
      meta: {
          moduleId: 'planningReview',
          decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
      },
      props: true,
      beforeEnter: checkAuthenticated,
  },
  {
    path: '/resourceplanning',
    name: 'ResourcePlanningView',
    component: () => 
        import(
            /* webpackChunkName: 'resource-planning-view' */ '../modules/projects/components/resource_planning/ResourcePlanningView'
        ),
    meta: {
        moduleId: 'resourcePlanning',
        decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    props: true,
    beforeEnter: checkAuthenticated && checkLinkedEmployee,
  },
];
